<template>
    <AboutMenu
      :menu="[
        { name: '人才理念', url: '/career' },
        { name: '先进典型', url: '/careerNews/advanced' },
        { name: '员工风采', url: '/careerNews/staff' },
        { name: '人才招聘', url: '/job' },
        { name: '人资动态', url: '/human' },
        { name: '人才政策', url: '/talent' },
      ]"
    />
</template>

<script>
import AboutMenu from "@/views/components/AboutMenu";

export default {
     components: {
    AboutMenu,

  }, 
}
</script>

<style lang="scss">

</style>